import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@homeleite/arch';
import { AdminGuard } from '../../core/guards/admin.guard';
import { ProducerDetailsComponent } from './producer-details/producer-details.component';
import { ProducersComponent } from './producers.component';

const BASE_PATH = 'producers';
const routes: Routes = [
  { path: BASE_PATH, redirectTo: `${BASE_PATH}/`, pathMatch: 'full' },
  {
    path: `${BASE_PATH}/`,
    component: ProducersComponent,
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    canActivate: [AuthGuard, AdminGuard],
    data: { title: 'Home Leite - Produtores' },
  },
  {
    path: `${BASE_PATH}/:id`,
    component: ProducerDetailsComponent,
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    canActivate: [AuthGuard, AdminGuard],
    data: { title: 'Home Leite - Produtor' },
  },
];

export const ProducersRoutes = RouterModule.forChild(routes);
